import type { PropsWithChildren } from "react";
import { Typography } from "@circle-react-uikit/Typography";

export const HeaderTitle = ({
  children,
}: PropsWithChildren<Record<string, unknown>>) => (
  <Typography.LabelMd color="text-dark" weight="semibold">
    {children}
  </Typography.LabelMd>
);
